'use strict';

define('vb/private/translations/bundleV2Definition',[
  'vb/private/log',
  'vb/private/pathHandler',
], (Log, PathHandler) => {
  const logger = Log.getLogger('/vb/private/translations/bundleV2Definition');
  /**
   * BundleV2Definition
   *
   * differences between this, and the original BundleDefinition
   *
   * - relative-to-container paths (starting with "./") are not supported; all paths are relative to the application,
   *   or absolute
   *
   * - path templates are not supported. this was never really used, but officially dropping support in new bundles.
   *
   * @todo: as of 09/29/2020, JET is not generating this format yet: JET-39285
   * simple example:
   *   define(() => ({
   *     "greeting": function (p){return "Hello, "+p["person"];},
   *     "heading": function (p){return "This is "+p["0"];},
   *   });
   *
   */
  class BundleV2Definition {
    /**
     * represents one translation bundle
     * @param name
     * @param evaluatedPath {string}
     * @param metadata {object} expressions are not evaluated
     * @param locale
     * @param relativePath
     */
    constructor(name, evaluatedPath, metadata, locale, relativePath = '') {
      //
      this.path = evaluatedPath;
      this.declaration = Object.assign({}, metadata);

      this.log = logger;
      this.name = name;
      this.default = metadata.default || false;

      // allow "./somepath", but not "../somepath".
      this.pathHandler = new PathHandler(this.path, relativePath, { allowParent: false, allowSelfRelative: true });
      this.map = null;

      this.stringFunctions = {}; // these will come directly from the JET-generated string bundle
    }

    /**
     * Whether or not the path is allowed based on the PathHandler config above;
     * Allow "./some/path", but don't allow "../some/path"
     *   { allowParent: false, allowSelfRelative: true }
     * @returns {boolean}
     */
    isAllowed() {
      return this.pathHandler.isAllowed();
    }


    /**
     */
    load(runtimeEnvironment) {
      return runtimeEnvironment.getV2Strings(this.pathHandler.getResolvedPath(), this.declaration)
        .then((v2Objects) => {
          Object.defineProperties(this, {
            map: {
              get: () => v2Objects.wrappers, // non-function accessors
            },
            stringFunctions: {
              get: () => v2Objects.functions, // the unaltered JET functions
            },
          });
          return this;
        });
    }

    /**
     * Called by TranslationContext, for the '$translations.format' EL function
     * @returns {*}
     */
    format(key, ...params) {
      if (this.stringFunctions[key]) {
        return this.stringFunctions[key](...params);
      }
      logger.warn(`Key ${key} not found in bundle ${this.name}, returning empty string`);
      return '';
    }
  }

  return BundleV2Definition;
});

